import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { TypePayments } from '../api/models';

@Directive({
  selector: '[paymentTypeStyle]',
  standalone: true,
})
export class PaymentTypeDirective implements OnInit {
  @Input('paymentTypeStyle') type: TypePayments;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi ';

    switch (this.type) {
      case TypePayments.DepositToTheAccount:
        classList += 'mdi-credit-card-outline mdi-26px tw-mx-2 text-danger';
        break;
      case TypePayments.Card:
        classList +=
          'mdi-credit-card-multiple-outline mdi-26px tw-mx-2 text-warning';
        break;
      case TypePayments.Cash:
        classList += 'mdi-cash mdi-26px tw-mx-2 text-success';
        break;
      case TypePayments.Cheque:
        classList += 'mdi-checkbook mdi-26px tw-mx-2 text-primary';
        break;
      case TypePayments.OnLine:
        classList += ' mdi-web mdi-26px tw-mx-2 text-blue';
        break;

      default:
        break;
    }
    return classList;
  }
}
